import type RegisterUser from '~/types/RegisterUser';

import { type User } from '~/types/User';

import { ActionKeys } from './constants';

interface ErrorObj {
  errorMessage: string;
}

export const register = (payload: RegisterUser, next: string) =>
  <const>{
    next,
    payload,
    type: ActionKeys.REGISTER,
  };

export const registerSuccess = (sessionToken: string, next: string) =>
  <const>{
    payload: { next, sessionToken },
    type: ActionKeys.REGISTER_SUCCESS,
  };

export const registerError = (err: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  email?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errorMessage: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  firstName?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  lastName?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  password?: any;
}) =>
  <const>{
    payload: { error: err },
    type: ActionKeys.REGISTER_ERROR,
  };

export const resendVerification = (withRedirect = true) =>
  <const>{
    payload: {
      withRedirect,
    },
    type: ActionKeys.RESEND_VERIFICATION,
  };

export const resendVerificationSuccess = () =>
  <const>{
    type: ActionKeys.RESEND_VERIFICATION_SUCCESS,
  };

export const resendVerificationError = (err: ErrorObj) =>
  <const>{
    payload: { error: err },
    type: ActionKeys.RESEND_VERIFICATION_ERROR,
  };

export const userDidAuthenticate = (payload: { user: User }) =>
  <const>{
    payload: { currentUser: payload.user },
    type: ActionKeys.USER_DID_AUTHENTICATE,
  };

export const initializeAnonymousGTM = () =>
  <const>{ type: ActionKeys.INITIALIZE_ANONYMOUS_TAG_MANAGER };

export const finishRegister = () =>
  <const>{
    type: ActionKeys.FINISH_REGISTER,
  };

export const clearAuthError = () =>
  <const>{
    type: ActionKeys.RESET_AUTH_ERROR,
  };

export type AuthActions =
  | ReturnType<typeof clearAuthError>
  | ReturnType<typeof finishRegister>
  | ReturnType<typeof initializeAnonymousGTM>
  | ReturnType<typeof register>
  | ReturnType<typeof registerError>
  | ReturnType<typeof registerSuccess>
  | ReturnType<typeof resendVerification>
  | ReturnType<typeof resendVerificationError>
  | ReturnType<typeof resendVerificationSuccess>
  | ReturnType<typeof userDidAuthenticate>;
